import { render } from "./DatalyticsApp.vue?vue&type=template&id=dff2fa6c&scoped=true"
import script from "./DatalyticsApp.vue?vue&type=script&lang=js"
export * from "./DatalyticsApp.vue?vue&type=script&lang=js"

import "./DatalyticsApp.vue?vue&type=style&index=0&id=dff2fa6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff2fa6c"]])

export default __exports__